import { useCallback, useState, ReactElement } from 'react';

import { ComplianceCrudForm } from './ComplianceCrudForm';
import { LenderDetails } from './LenderDetails';
import type { LenderSectionProps } from '../interfaces';

export const LenderDetailsSection = ({ details, isFetching, refresh }: LenderSectionProps): ReactElement => {
  const [complianceCrudOpen, setComplianceCrudOpen] = useState(false);

  const onOpenComplianceCrud = useCallback(() => {
    setComplianceCrudOpen(true);
  }, []);

  const onCloseComplianceCrud = useCallback(() => {
    setComplianceCrudOpen(false);
  }, []);

  return (
    <>
      <LenderDetails details={details} isFetching={isFetching} onEditCompliance={onOpenComplianceCrud} />
      {details && complianceCrudOpen && <ComplianceCrudForm details={details} onClose={onCloseComplianceCrud} refresh={refresh} />}
    </>
  );
};
